export default {
	props: {
		/**
		 * Can be any color from `colors/_palette.scss`.
		 */
		color: {
			type: String,
			default: 'neutral'
		},
		/**
		 * Sets a darker color on the background.
		 */
		isSolid: {
			type: Boolean,
			default: false
		},
		/**
		 * Font family.
		 * Can be: `ui`, `display` or `mono` or a custom font family.
		 */
		fontFamily: {
			type: String,
			default: 'ui',
			validator: function(value) {
				// The value must match one of these strings
				return [ 'ui', 'display', 'mono' ].indexOf(value) !== -1;
			}
		},
		/**
		 * The value of the element.
		 */
		value: [ String, Number ],
		/**
		 * Used to set the value bold
		 */
		bold: Boolean,
		/**
		 * The size of the badge. Available valus: `small(sm), medium(md), large(lg)`.
		 */
		size: {
			type: String,
			default: 'medium',
			validator: function(value) {
				// The value must match one of these strings
				return [ 'sm', 'small', 'md', 'medium', 'lg', 'large' ].indexOf(value) !== -1;
			}
		}
	},
};